export const DATA_1 = {
    name: '香港學生睡眠',
    tabs: [
        {
            name: '報章評論',
            url: 'http://news.example.com/student-sleep-school-start',
            contents: [
                {
                    type: 'image',
                    src: '/secondary/tasks/rp4.png',
                },
                {
                    type: 'html',
                    html: '<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每天早上，總有一些學生拖着書包、沒精打采地走進校門，甚至上完第一節課後仍然十分困倦。這幅常見景象，令「是否該把早會或第一節課延後」再次成為教育界爭議。這個建議並非毫無道理，但延後二十分鐘能否解決睡眠不足，卻不宜過早下定論。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;香港已有學校開始嘗試調整時間。以明智中學為例，學校留意到部分學生在早上首兩節課精神不集中，因此計劃在下學期試行新的時間安排，把早會由上午8時延至8時20分，並相應調整第一節課、午膳和放學時間。<br/><br/>'
                },
                {
                    type: 'title',
                    text: '試行安排時間表'
                },
                {
                    type: 'html',
                    html: `
<table class='w-full' style='border: 1px solid #9CB8D3;'>
  <tr>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>項目</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>現行時間</th>
    <th class='text-center' style='background-color: #EDF5F8; border: 1px solid #9CB8D3;'>試行時間</th>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>校門開放</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午7:45</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>早會</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:00</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:20</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>第一節課</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午8:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>上午9:00</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>午膳</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午12:40</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午1:10</td>
  </tr>
  <tr>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>放學</td>
    <td class='text-center' style='border: 1px solid #9CB8D3;'>下午4:00</td>
    <td class='text-center'style='border: 1px solid #9CB8D3;'>下午4:20</td>
  </tr>
</table>
`
                },
                {
                    type: 'html',
                    html: '<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;此外，明智中學還計劃在試行期間收集教師的課堂觀察紀錄和學生問卷，並舉辦介紹睡眠與學業表現的家長講座。這些措施是良好的嘗試，但是否真的有幫助，仍要根據試行後學生的課堂專注度以及整體狀態來判斷。如果效果不明顯，學校也應重新檢視時間安排是否切合學生的實際需要。不同學校的校情、學生居住地點、交通和午膳安排不盡相同，也不宜立刻要求所有學校實行。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;更重要的是，社會和學校不應把延後早間課堂看成解決學生睡眠問題的簡單答案。真正值得關注的，不是早會究竟延後多少分鐘，而是學生能否實現更充足和規律的作息，並在課堂保持較好的精神狀態。<br/><br/><br/><br/>'
                }
            ]
        },

        {
            name: '科普新聞',
            url: 'http://health.example.com/student-sleep-health',

            contents: [
                {
                    type: 'html',
                    html: `<br/>`
                },
                {
                    type: 'image',
                    src: '/secondary/tasks/rp5.png',
                },
                {
                    type: 'html',
                    html: `
                    <div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%;'>
                        <div class='w-full font-bold text-white flex flex-row items-center' style='background-color: #3F96FD; padding: 16px; gap:16px;'>
                            <div style='width:12px; height:39px; background-color: #FF7961;'></div>
                            新聞 | 睡眠與健康 
                        </div>
                        <br/>
                        <b>小三睡9.5小時 中三睡8.5小時 成績最佳</b>
                        <br/>
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本港青少年睡眠不足的情況越來越嚴重。香港中文大學精神科學系教授陳秀雯指出，受成績至上觀念影響，不少家長輕視睡眠健康，令學童不得不犧牲休息時間來溫書。她引用美國國家睡眠基金會的睡眠時長建議（見圖1），但達標港生只佔少數。她指出，學生「想睡也睡不到」，除了自身壓力，也與課堂安排、功課數量等學校因素有關。</p>
                        <br/>
                        <div class='w-full flex justify-center items-center flex flex-col' style='margin-top: 16px;'>
                            <b>圖1：各年齡層建議睡眠時長</b><br/>
                        </div>
                    </div>
                `},
                {
                    type: 'image',
                    src: '/secondary/tasks/rp6.png',
                    enableEnlargeAndRecordTimeSpent: true,
                    alt: '圖1：各年齡層建議睡眠時長'
                },
                  {
                    type: 'html',
                    html: `
                     <div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 0%; padding-right: 0%;'>
                        <br/>
                        <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                            資料來源：美國國家睡眠基金會（National Sleep Foundation），2015年
                        </div>
                        <br/>
                            <br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了學校課業，社會的補習文化亦十分普遍。陳秀雯認為，家長為子女安排興趣班、補習班之餘，亦應制定健康的睡眠時間表，「今天的事做不完，可否明天再算呢？分數重要之餘，會否孩子的精神健康更加重要呢？」她還提到團隊前年一項研究，指出港生睡眠時間與學業成績呈明顯「倒U形」關係。也就是說，學生的睡眠時間過短或太長，學業成績都可能較差。其中，小三生每天睡眠9.5小時、中三生每天睡眠8.5小時的成績最好。她重申，增加一些睡眠時間並不會妨礙學童取得好成績，並呼籲家長重視兒童的睡眠習慣。</p>
                        <br/>
                            <b>亞洲人睡較少 港人遲睡遲起 假日補眠或擾亂作息</b>
                            <br/>
                        
                        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了睡眠不足，許多港人亦有晚睡、假日補眠等睡眠問題。香港中文大學精神科學系系主任榮潤國教授指出，海外研究曾比較不同國家及地區人士的睡眠習慣。結果顯示，亞洲人睡眠時間較短，而香港人在工作日的睡覺時間最遲，青少年也有相似情況。都市人普遍利用週末或假期補眠，但也無法彌補平日睡眠不足，反而更加擾亂作息，導致睡眠節奏紊亂及社交時差（social jetlag），即假日作息就像生活在另一時區，並可能增加情緒及行為問題。</p>
                        
                        <br/>
                        <br/>
                    </div>

                    `
                }
            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '最近，你和同學子晴上早課時總是提不起精神，還不時打呵欠。一天小息時，你們在社交平台看到一篇討論學校應否延後早會或第一節課的報章評論，便好奇地點進去閱讀。<br/><br/>點擊「下一頁」來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 根據報章評論，以下哪項<b>最能概括</b>明智中學校方的處理方式？',
            subtitle: '參考右側「報章評論」，作答本題。',
            options: [
                { text: 'A. 縮短在校時間，觀察學生睡眠變化' },
                { text: 'B. 調整時間安排，配合講座及成效檢視', correct: true },
                { text: 'C. 舉辦家長講座，再決定是否調整時間' },
                { text: 'D. 依靠教師觀察，暫不收集學生意見' }
            ],
            tab: 0,
        },
        {
            id: '2',
            type: '表格問題',
            question: '2. 根據報章評論內容及「明智中學試行安排時間表」，判斷以下說法是否正確。',
            subtitle: '參考右側的「報章評論」，作答本題。',
            header: ['陳述', '正確', '錯誤'],
            table: [
                { text: '（1）報章評論只說部分學生早上精神不集中，不能判斷問題是否普遍。', correct: 1 },
                { text: '（2）試行新時間表後，早會時間延後了二十分鐘。', correct: 1 },
                { text: '（3）明智中學的試行安排，可直接推廣至所有學校。', correct: 2 },
                { text: '（4）若試行新時間表後，學生早課表現有所改善，便足以證明延後早會有效。', correct: 2 }
            ],
        },
        {
            type: 'display-text',
            html: '看到報章評論提到學生的睡眠情況和學生的精神狀態相關，子晴好奇地說：「那麼睡眠會不會影響上課表現呢？」你們在網上搜尋相關資料，找到一篇介紹香港學童睡眠問題的健康新聞。<br/><br/>點擊「下一頁」來閱讀第二個來源。'
        },
        {
            id: '3',
            type: '填寫問題',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            question_prefix: '3. 根據圖1，18至65歲成人每天的建議睡眠時長為',
            question_postfix_: '至',
            question_postfix: '小時。',
            isMultipleAnswer: true,
            correct: '7',
            correct2: '9'
        },
        {
            id: '4',
            type: '選擇題',
            question: '4. 科普新聞最後一段提到，週末或假期補眠可能導致「社交時差」。這裏的「社交時差」是指甚麼？',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            options: [
                { text: 'A. 外出旅行跨越時區，身體未能適應當地時間' },
                { text: 'B. 深夜使用社交媒體，使每天的入睡時間延後' },
                { text: 'C. 平日與假日作息不同，如同身處於另一時區', correct: true },
                { text: 'D. 社交活動時間過長，導致每天睡眠時長不足' }
            ],
            tab: 0,
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. 子晴準備在2026年的家長講座中，把圖1介紹為「目前最新的睡眠時數建議」。根據圖1，以下哪項處理最恰當？',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            options: [
                { text: 'A. 先查核該機構其後有否更新相關睡眠建議', correct: true },
                { text: 'B. 資料來自專業機構因此可直接保留該說法' },
                { text: 'C. 改為介紹香港學生目前實際的睡眠時間' },
                { text: 'D. 改為比較圖中各年齡層的建議睡眠時數' }
            ],
            tab: 0,
        },
        {
            id: '6',
            type: '選擇題',
            question: '6. 科普新聞第二段引用「分數重要之餘，會否孩子的精神健康更加重要呢？」這個反問句，主要作用是甚麼？',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            options: [
                { text: 'A. 承接前文，引出成績討論。' },
                { text: 'B. 保留立場，呈現不同觀點。' },
                { text: 'C. 緩和語氣，避免直接批評。' },
                { text: 'D. 引發思考，反思兩者取捨。', correct: true }
            ],
            tab: 0,
        },
        {
            id: '7',
            type: '表格問題2',
            question: '7. 一個為14至17歲學生舉辦的兩星期住宿音樂營，發現部分營員早上排練時精神不集中。負責人準備調整營員的睡眠和作息安排。綜合各來源，以下哪個方案最合適？',
            subtitle: '結合兩個來源，作答本題。',
            table: [
                {
                    title: ' ',
                    rows: [
                        'A',
                        'B',
                        'C',
                        'D'
                    ]
                },
                {
                    title: '每晚睡眠安排',
                    rows: [
                        "晚上11時至早上6時",
                        "晚上11時至早上7時",
                        "晚上11時至早上6時",
                        "晚上11時至早上7時"
                    ]
                },
                {
                    title: '週末作息',
                    rows: [
                        '與平日相近',
                        '與平日相近',
                        '延後起床補眠',
                        '延後起床補眠',
                    ]
                },
                {
                    title: '效果觀察',
                    rows: [
                        '比較演奏熟練程度',
                        '比較排練專注情況',
                        '比較排練專注情況',
                        '比較演奏熟練程度'
                    ]
                }
            ],
            correct: 'B',
            tab: 0,
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 子晴整理報章評論和科普新聞時，想找出兩個來源都有直接涉及的內容。以下哪項符合條件？',
            subtitle: '結合兩個來源，作答本題。',
            options: [
                { text: 'A. 睡眠時間和作息規律', correct: true },
                { text: 'B. 到校時間與課堂狀態' },
                { text: 'C. 假日補眠與社交時差' },
                { text: 'D. 功課數量與睡眠時間' }
            ],
            tab: 0,
        },
        {
            id: '9',
            type: '拖放式問題',
            question: '9. 根據健康新聞及圖1，把最合適的選項拖放到①至③。每個選項只可使用一次，有三個選項不會用到。',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            dragAndDrop: [
                {
                    title: '現象',
                    rows: [
                        {
                            type: '拖放格',
                            correct: 'A. 俊軒是小四學生，他每天約睡7小時。',//AED
                        },
                        {
                            type: '文字',
                            text: "小三生每天睡9.5小時、中三生每天睡8.5小時時，學業成績最佳。"
                        }, {
                            type: '文字',
                            text: "中學生阿文平日每晚約睡7.5小時，計劃只靠週末睡到中午補眠。"
                        },
                    ]
                },
                {
                    title: '推斷',
                    rows: [
                        {
                            type: '文字',
                            text: "他的睡眠時數低於建議範圍。"
                        }, {
                            type: '拖放格',
                            correct:'E. 兩組成績最佳的睡眠時數均符合年齡建議。'
                        }, {
                            type: '拖放格',
                            correct: 'D. 他平日睡眠未達標，不能只靠週末補眠。'
                        },
                    ]
                },
                {
                    title: '來源',
                    rows: [
                        {
                            type: '文字',
                            text: '陳秀雯教授<br/>美國國家睡眠基金會'
                        },
                        {
                            type: '文字',
                            text: '陳秀雯教授<br/>美國國家睡眠基金會'
                        },
                        {
                            type: '文字',
                            text: '榮潤國教授<br/>美國國家睡眠基金會'
                        }
                    ]
                }
            ],
            dragAndDropOptions: [
                { text: "A. 俊軒是小四學生，他每天約睡7小時。" },
                { text: "B. 中三生成績最佳的睡眠時數低於建議下限。" },
                { text: "C. 他假日多睡，便能彌補平日睡眠不足。" },
                { text: "D. 他平日睡眠未達標，不能只靠週末補眠。" },
                { text: "E. 兩組成績最佳的睡眠時數均符合年齡建議。" },
                { text: "F. 他平日睡眠已達標，週末補眠或擾亂作息。" }
            ]
        },
        {
            id: '10',
            type: '短句作答題',
            question: '10. 科普新聞指出，睡眠過長時，學業成績也可能較差；陳秀雯教授則表示，增加一些睡眠時間並不會妨礙取得好成績。兩者是否矛盾？請根據科普新聞內容進行解釋。',
            subtitle: '參考右側的「科普新聞」，作答本題。',
            score:4,
        },
    ]
}
